import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { DataFhirAdapter, DataFhirModel } from '../data.model';
import { DictionariesCollectionService } from '../dictionaries/dictionaries-collection.service';
import { RoomEvent } from '@core/models/matrix-messenger/room-event.model';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
export interface AuditEvent extends DataFhirModel<fhir4.AuditEvent> {
  text: string;
  icon: string;
  type: string;
  read: boolean;
  path?: string;
  count?: number;
  directChat?: boolean;
  room?: RoomEvent;
  time: Date;
}

@Injectable({
  providedIn: 'root',
})
export class NotificationsAdapter extends DataFhirAdapter<AuditEvent> {
  constructor(protected dictionariesCollection: DictionariesCollectionService) {
    super('AuditEvent', dictionariesCollection);
  }

  protected blankResource(): fhir4.AuditEvent {
    return {
      resourceType: 'AuditEvent',
      recorded: formatDate(new Date(), 'yyyy-MM-ddTHH:mm', 'en'),
      agent: null,
      source: null,
      type: null,
    };
  }

  fromResource$(auditEvent: fhir4.AuditEvent): Observable<AuditEvent> {
    return super.fromResource$(auditEvent).pipe(
      map((baseItem) => {
        return {
          ...baseItem,
          // id: baseItem.id,
          type: baseItem._resource.type.display,
          icon: '',
          read: baseItem._resource.action === 'R',
          text: baseItem._resource.outcomeDesc,
          time: new Date(baseItem._resource.recorded),
        };
      }),
    );
  }
}
